import {Well} from "react-bootstrap"
import styled from "styled-components"


export default styled(Well)`
  background-color: #BDBDBA;
  padding: 9px;
`
